import { useState } from 'react';
import { Link, Navigate } from '@tanstack/react-router';
import { useRhinoContext } from '@rhino-project/core';
import { useSignInAction } from '@rhino-project/core/queries';
import { useHarborlightSession } from '../hooks/useHarborlightSession';

// Ported 1:1 from the source repository (client/src/pages/LoginPage.jsx).
// Standalone page (no app shell). Wired to Rhino devise-token-auth sign-in.
const LoginPage = () => {
  const { user } = useRhinoContext();
  const { roleHomePath } = useHarborlightSession();
  const [email, setEmail] = useState('guest@hotel.com');
  const [password, setPassword] = useState('password123');
  const [error, setError] = useState('');
  const signIn = useSignInAction();
  const busy = signIn.isPending;

  // Once authenticated (either already signed in or right after a successful
  // sign-in) redirect to the role home. Mirrors the source's guard exactly.
  if (user) return <Navigate to={roleHomePath} replace />;

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    try {
      await signIn.mutateAsync({ email, password } as never);
    } catch {
      setError('Invalid email or password.');
    }
  }

  return (
    <div className="auth-layout">
      <div className="auth-visual fade-up">
        <div>
          <div className="display-title display-4 mb-2">room stay 1</div>
          <p className="fs-5 mb-0 opacity-75">
            Sign in as admin, staff, or guest to manage or book your stay.
          </p>
        </div>
      </div>
      <div className="auth-form-wrap">
        <div className="surface-panel p-4 p-md-5 w-100 auth-card fade-up-delay">
          <h1 className="display-title h2 mb-1">Welcome back</h1>
          <p className="text-secondary mb-4">
            Use the demo accounts or your own guest login.
          </p>
          {error && <div className="alert alert-danger">{error}</div>}
          <form onSubmit={onSubmit} className="d-grid gap-3">
            <div>
              <label className="form-label" htmlFor="email">
                Email
              </label>
              <input
                id="email"
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="form-label" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-sea btn-lg"
              disabled={busy}
            >
              {busy ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
          <p className="small text-secondary mt-4 mb-2">
            Demo logins (password: password123)
          </p>
          <ul className="small text-secondary mb-4">
            <li>admin@hotel.com</li>
            <li>staff@hotel.com</li>
            <li>guest@hotel.com</li>
          </ul>
          <p className="mb-0">
            New guest? <Link to="/register">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
